import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  HomeIcon,
  CalendarIcon,
  ChatBubbleLeftIcon,
  ChartBarIcon,
  CogIcon,
  UserGroupIcon,
  ArrowLeftOnRectangleIcon,
  BellIcon
} from '@heroicons/react/24/outline';

const menuItems = [
  { icon: HomeIcon, label: 'Overview', path: '/manager' },
  { icon: CalendarIcon, label: 'Bookings', path: '/manager/bookings' },
  { icon: ChatBubbleLeftIcon, label: 'Messages', path: '/manager/messages', badge: '4' },
  { icon: ChartBarIcon, label: 'Analytics', path: '/manager/analytics' },
  { icon: UserGroupIcon, label: 'Guests', path: '/manager/guests' },
  { icon: CogIcon, label: 'Settings', path: '/manager/settings' },
];

const DashboardSidebar: React.FC = () => {
  const location = useLocation();

  return (
    <motion.aside
      initial={{ x: -300 }}
      animate={{ x: 0 }}
      transition={{ duration: 0.5, type: 'spring', stiffness: 100 }}
      className="w-64 bg-white border-r border-gray-200 min-h-screen p-4 shadow-sm relative"
    >
      <div className="flex items-center px-2 mb-8">
        <img 
          src="https://a0.muscache.com/airbnb/static/logotype_favicon-21cc8e6c6a2cca43f061d2dcabdf6e58.ico"
          alt="Airbnb"
          className="h-8 w-auto"
        />
        <span className="ml-2 text-xl font-semibold text-gray-900">Host Dashboard</span>
      </div>

      <div className="mb-8 px-3">
        <div className="flex items-center space-x-3 bg-gray-50 rounded-xl p-3">
          <img
            src="https://picsum.photos/200/200?random=1"
            alt="Profile"
            className="h-10 w-10 rounded-full object-cover border-2 border-white shadow-sm"
          />
          <div>
            <h3 className="text-sm font-medium text-gray-900">Alex Johnson</h3>
            <p className="text-xs text-gray-500">Premium Host</p>
          </div>
        </div>
      </div>

      <nav className="space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`
                flex items-center px-3 py-2.5 text-sm font-medium rounded-xl
                transition-all duration-200 group relative
                ${isActive 
                  ? 'bg-red-50 text-airbnb-red shadow-sm'
                  : 'text-gray-700 hover:bg-gray-50'
                }
              `}
            >
              <Icon className={`
                h-5 w-5 mr-3 transition-colors duration-200
                ${isActive ? 'text-airbnb-red' : 'text-gray-400 group-hover:text-gray-500'}
              `} />
              {item.label}
              {item.badge && (
                <span className="absolute right-3 top-1/2 -translate-y-1/2 bg-airbnb-red text-white text-xs font-medium px-2 py-0.5 rounded-full">
                  {item.badge}
                </span>
              )}
            </Link>
          );
        })}
      </nav>

      <div className="absolute bottom-4 w-56 space-y-2">
        <button className="flex items-center px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-xl w-full transition-colors duration-200">
          <BellIcon className="h-5 w-5 mr-3 text-gray-400" />
          Notifications
          <span className="ml-auto bg-airbnb-red text-white text-xs font-medium px-2 py-0.5 rounded-full">
            3
          </span>
        </button>
        <button className="flex items-center px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-xl w-full transition-colors duration-200">
          <ArrowLeftOnRectangleIcon className="h-5 w-5 mr-3 text-gray-400" />
          Sign Out
        </button>
      </div>
    </motion.aside>
  );
};

export default DashboardSidebar;